import { useEffect } from 'react';
import AdministrationTable from './AdministrationTable'
import ClientsTree from './ClientsTreeNew'
import "../../styles/Administration.css";
import "rc-tree/assets/index.css"
import { ResizeCallbackArgs, useResizable } from 'react-resizable-layout';
import { centerClient } from '../../shared/clients';
import context, { IClientsTreeNode, localStorageKeys } from './context/shared';
import { observer } from 'mobx-react-lite';
import { ITreeNode, removeChildProperty } from 'blick.react.utils';
import { useIsMobile } from '../shared';
import { TreeNode } from '../../shared/generated';
import { NodeTypes } from '../variables';

const Administration = observer(() => {
    const resizeHandle = (args: ResizeCallbackArgs) => {
        localStorage.setItem(localStorageKeys.clientsTreeWidth, args.position.toString());
    }
    const { refreshTreeCounter, currentNode } = context;
    const getClientsTreeWidth = () => {
        let clientstreeWidth = 300;

        const lsClientsTreeWidth = localStorage.getItem(localStorageKeys.clientsTreeWidth);
        if (lsClientsTreeWidth && !isNaN(parseInt(lsClientsTreeWidth)))
            clientstreeWidth = parseInt(lsClientsTreeWidth);

        return clientstreeWidth;
    }
    const { position, separatorProps } = useResizable({
        axis: 'x',
        initial: getClientsTreeWidth(),
        onResizeEnd: resizeHandle,
    })

    const { setClientsTreeData, setIsClientsTreeDataLoading, autoRefreshEnabled, autoRefreshIntervalSec } = context; 

    useEffect(() => {
        setIsClientsTreeDataLoading(true);
        loadClientsTree();
    }, [refreshTreeCounter]);

    useEffect(() => {
        if (!autoRefreshEnabled)
            return;
        const timerId = setInterval(() => {
            if (document.hidden || context.isClientsTreeDataLoading)
                return;
            context.refreshTree();
        }, autoRefreshIntervalSec * 1000);
        return () => clearInterval(timerId);
    }, [autoRefreshEnabled, autoRefreshIntervalSec]);

    const loadClientsTreeSuccess = (data: TreeNode[]) => {        
        setClientsTreeData(removeChildProperty(data as unknown as ITreeNode[]) as unknown as IClientsTreeNode[]);
    }
    function loadClientsTree() {
        centerClient.getClientsTree()
            .then((res) => {
                const data = res.data;
                if (data)
                    loadClientsTreeSuccess(data);
            })
            .catch(() => void 0)
            .finally(() => setIsClientsTreeDataLoading(false));
    }

    const Mobile = () =>
        <div id="administrationContainer" style={{ flexDirection: 'column', flex: 1, minHeight: 0 }}>
            <div className={'mobileClientsSection' + (currentNode?.type === NodeTypes.account ? ' mobileClientsCompact' : '')}
                style={currentNode?.type === NodeTypes.account ? { flex: '0 0 auto' } : { flex: 1, minHeight: 0 }}>
                <ClientsTree showTopButtons={true} treeKey={"center-openedTreeNodes"} />
            </div>
            <div id="devicesTableContainer" className='marginBottom'
                style={currentNode?.type === NodeTypes.account ? { flex: 1, minHeight: 0 } : { flex: '0 0 auto' }}>
                <AdministrationTable />
            </div>
        </div>  
    
    return (
        useIsMobile() ? <Mobile /> :
        <div id="administrationContainer">
            <div id="clientsTreeContainer" style={{ width: position }}>
                <ClientsTree showTopButtons={true} treeKey={"center-openedTreeNodes" } />
            </div>
            <hr className="separator separator-vertical" {...separatorProps}>
            </hr>
            <div id="devicesTableContainer" style={{ width: 'calc(100% - ' + position + 'px)', paddingLeft:'1rem' }}>
                <AdministrationTable />
            </div>
        </div>  
    );    
})

export default Administration;